import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { DialogActions, TextField } from "@material-ui/core";
import { onPreventEnterSubmitting } from "../../utils/utils";
import { createCompanyProfile } from "../../services/setup/company-profile/companyProfileService";
import Swal from "sweetalert2";
import { OrderList } from "primereact/orderlist";
import DialogLayout from "../../partials/content/DialogLayout";
import {
  FormSelectField,
  FormTextField,
} from "../../partials/content/Forms/FormField";
import MapPlaces from "../../partials/content/MapPlaces";
const CreateCompanyProfile = ({
  activeStep,
  handleBack,
  handleSkip,
  handleNext,
  companyProfile,
  currencyOptions,
  countryOptions,
  handleReloadCompanyProfile,
}) => {
  const [searchTimezone, setSearchTimezone] = useState("");
  const [openSearchTimezone, setOpenSearchTimezone] = useState(false);
  const [timezones, setTimezones] = useState(
    Intl.supportedValuesOf("timeZone")
  );
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  useEffect(() => {}, []);

  const companyProfileFormSchema = yup.object().shape({
    ID: yup.number(),
    companyName: yup
      .string()
      .required("Company Name is required")
      .max(255, "Company Name maximum characters is 255"),
    phone: yup
      .string()
      .required("Phone Number is required")
      .matches(
        /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
        "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
      )
      .max(50, "Phone Number maximum characters is 50"),
    email: yup
      .string()
      .email("Email must be valid. e.g. joe@invifo.com")
      .required("Email is required")
      .max(50, "Email maximum characters is 50"),
    website: yup
      .string()
      .matches(
        /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/,
        "Website url must be valid. e.g. https://invifo.com or www.invifo.com"
      )
      .max(50, "Website maximum characters is 50"),
    taxpayerID: yup.string().max(50, "Taxpayer ID maximum characters is 50"),
    address: yup
      .string()
      .required("Address is required")
      .max(255, "Address maximum characters is 255"),
    city: yup
      .string()
      .required("City is required")
      .max(50, "City maximum characters is 50"),
    province: yup.string().max(50, "Province maximum characters is 50"),
    countryCode: yup.string(),
    postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
    currencyID: yup
      .number()
      .required("Currency is required")
      .moreThan(0, "Currency is required"),
  });
  return (
    <Formik
      initialValues={companyProfile}
      validationSchema={companyProfileFormSchema}
      enableReinitialize={true}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Company Profile ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              createCompanyProfile(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                handleReloadCompanyProfile();
                handleNext();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="horizontal-step-content">
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <FormTextField label="Company Name" name="companyName" />
                <FormTextField label="Phone Number" name="phone" />
                <FormTextField label="Email" name="email" />
                <FormTextField label="Website" name="website" />
                <FormSelectField
                  label="Base Currency"
                  name="currencyID"
                  options={currencyOptions}
                />
                <FormTextField
                  label="Taxpayer Identification Number"
                  name="taxpayerID"
                />
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <FormTextField
                  label="Address"
                  name="address"
                  mapsButton
                  onMapsClick={() => {
                    setOpenSearchMapPlaces(true);
                  }}
                />
                <FormTextField label="City" name="city" />
                <FormTextField label="Province / State" name="province" />
                <FormSelectField
                  label="Country"
                  name="countryCode"
                  options={countryOptions}
                />
                <FormTextField label="Postal Code" name="postalCode" />
                <FormTextField
                  label="Timezone"
                  name="timezone"
                  searchButton
                  readonly
                  onSearchClick={() => {
                    setOpenSearchTimezone(true);
                  }}
                />
              </div>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-warning btn-md btn-pill btn-bold"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              <i className="fas fa-arrow-circle-left"></i>
              Back
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-arrow-circle-right"></i>
              Next
            </button>
          </DialogActions>
          <DialogLayout
            open={openSearchTimezone}
            title="Search Timezone"
            onCloseDialog={() => {
              setOpenSearchTimezone(false);
            }}
            maxWIdth="sm"
          >
            <TextField
              label="Search Timezone"
              value={searchTimezone}
              variant="outlined"
              size="small"
              margin="normal"
              style={{ width: "100%" }}
              onChange={(e) => {
                if (e.target.value === "") {
                  setTimezones(Intl.supportedValuesOf("timeZone"));
                } else {
                  const timezonesFilter = timezones.filter((item) =>
                    item.match(new RegExp(e.target.value, "i"))
                  );
                  setTimezones(timezonesFilter);
                }
                setSearchTimezone(e.target.value);
              }}
            />
            <OrderList
              id="orderlistwithoutcontrol"
              value={timezones}
              itemTemplate={(item) => {
                return (
                  <div
                    className="px-3 py-2"
                    onClick={() => {
                      setFieldValue("timezone", item);
                      setOpenSearchTimezone(false);
                    }}
                  >
                    {item}
                  </div>
                );
              }}
              header="Timezones"
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchTimezone(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchMapPlaces}
            title="Search Address on Maps"
            onCloseDialog={() => {
              setOpenSearchMapPlaces(false);
            }}
            maxWIdth="lg"
            minHeight={true}
          >
            <MapPlaces
              address={values.address}
              city={values.city}
              province={values.province}
              countryCode={values.countryCode}
              postalCode={values.postalCode}
              onPinLocation={(
                selectedFormattedAddress,
                selectedShortAddressComponents,
                selectedLongAddressComponents,
                selectedAddress,
                selectedCity,
                selectedProvince,
                selectedCountryCode,
                selectedPostalCode
              ) => {
                setFieldValue(`address`, selectedAddress);
                setFieldValue(`city`, selectedCity);
                setFieldValue(`province`, selectedProvince);
                setFieldValue(`countryCode`, selectedCountryCode);
                setFieldValue(`postalCode`, selectedPostalCode);
                setOpenSearchMapPlaces(false);
              }}
              onCloseDialog={() => {
                setOpenSearchMapPlaces(false);
              }}
            />
          </DialogLayout>
        </form>
      )}
    </Formik>
  );
};

export default CreateCompanyProfile;
